export default {
  // 模式
  "common.mode.auto": "Samostalno korištenje proizvedene energije",
  "common.mode.economy": "Ekonomski način rada",
  "common.mode.exigency": "Hitni način rada",

  // 设备
  "common.grid": "Električna mreža",
  "common.evChargers": "Punjači za električna vozila",
  "common.evCharger": "Punjač za električno vozilo",
  "common.pv": "Fotovoltaika",
  "common.inverter": "Invertor",
  "common.pcs": "Invertor + baterija",
  "common.terminal": "Terminalno uređaj",
  "common.airc": "Klima uređaj",
  "common.engine": "Motor",
  "common.battery": "Baterija",
  "common.metter": "Električni brojač",
  "common.other": "Ostalo",
  "common.power": "Snaga",
  "common.powerTotal": "Ukupna snaga",
  "common.voltage": "Napon",
  "common.electricity": "Električna energija",
  "common.current": "Struja",
  "common.homeUsage": "Ukupna opterećenje kuće",
  "common.battery.power": "Snaga baterije",

  // 数据
  "common.noDataAvailable": "Trenutno nema podataka~",
  "common.tips": "Napomena",
  "common.reset": "Resetiraj",
  "common.currencyUnit": "¥",
  "common.submiting": "Slanje u tijeku, molimo pričekajte...",
  "common.close": "Zatvori",
  "common.from": "Iz",
  "common.useIn": "Za",
  "common.energyPercent": "Postotak toka energije",
  "common.dataFlow": "Tok podataka",
  "common.getDataIng": "Dohvaćanje podataka u tijeku, molimo pričekajte...",
  "common.pageLoading": "Sadržaj stranice se učitava, molimo pričekajte...",
  "common.reseting": "Resetiranje sadržaja stranice, molimo pričekajte...",
  "common.save": "Spremi",
  "common.onlyNumberTips": "Moguće je unijeti samo brojeve",
  "common.offline": "Offline",
  "common.online": "Online",
  "common.fault": "Greška",
  "common.charge": "Punjenje",
  "common.discharge": "Praznjenje",
  "common.buy": "Kupi",
  "common.sell": "Prodaj",
  "common.loadingInfo": "Učitavanje u tijeku, molimo pričekajte...",

  // 
  "common.moreFeatures": "Više funkcija",
  "common.confirm": "Potvrdi",
  "common.saveing": "Spremanje u tijeku, molimo pričekajte...",
  "common.searchPlacholder": "Unesite ključne riječi za pretragu",
  "common.iSee": "Razumijem",
  "common.pageErrorTips1": "Ops, došlo je do greške na stranici~",
  "common.pageErrorTips2": "Pokušajte osvježiti stranicu ili kontaktirati podršku~",
  "common.refresh": "Osvježi",
  "common.backToHome": "Povratak na početnu",
  "common.checkTips": "Provjera u tijeku, molimo pričekajte...",
  "common.back": "Povratak",
  "common.cancel": "Odustani",
  "common.optional": "Neobavezno",
  "common.required": "Obavezno",
  "common.status": "Status",
  "common.statusNoDelete": "Nije obrisano",
  "common.statusDelete": "Obrisano",
  "common.submit": "Pošalji",
  "common.disable": "Onemogući",
  "common.enable": "Omogući",
  "common.year": "godina",
  "common.month": "mjesec",
  "common.day": "dan",
  "common.version": "Verzija:",
  "common.backHome": " Povratak na početnu",
  "common.backHomeSorry": " Nažalost, stranica se izgubila",
  "common.requestTips1": "Obrada podataka u tijeku, nemojte slati ponovo",
  "common.requestTips2": "Sistemsko obavijestenje",
  "common.requestTips3": "Status prijave je istekao, prijavite se ponovo",
  "common.requestTips4": "Prijavi se ponovo",
  "common.requestTips5": "Neispravna sesija ili sesija je istekao, prijavite se ponovo.",
  "common.requestTips6": "Greška na poslužitelju, molimo pokušajte ponovo kasnije.",
  "common.requestTips7": "Istek vremena zahtjeva za sistemsko sučelje",
  "common.requestTips8": "Sistemsko sučelje",
  "common.requestTips9": "Greška",
  "common.iknow": "Razumijem",
  "common.logoutSuccess": "Odjava uspješna",
  
  // 了解更多组件
  "common.knowMore.title": "Za više informacija, kontaktirajte Beineng",
  "common.knowMore.email": "Kontakt e-pošta",
  "common.knowMore.phone": "Kontakt telefon",
  "common.knowMore.wechat": "Kontakt WeChat",
  "common.knowMore.website": "Adresa službene web stranice",
  "common.knowMore.address": "Kontakt adresa",
  "common.knowMore.addressDetail": "Soba 1205, soba 1301, zgrada 5, ulica Qinghe 8, Huangjingkeng, opština Huangjiang, grad Dongguan, kanton Guangdong",
  
  // 本地连接组件
  "common.localConnection": "Lokalna veza",
  "common.operateInApp": "Izvršite akciju u aplikaciji!",
  
  "common.enbleStaus": "Status omogućavanja",
  "common.battery.status": "Bez punjenja i praznjenja",

  "account.forgetThePassword": "Zaboravljena lozinka",
  "account.logInDirectly": "Prijavi se odmah",
  "account.tips1": "Preusmjeravanje na stranicu u tijeku, molimo pričekajte...",
  "account.tips2": "Prvo pročitajte i prihvatite uvjete korištenja!",
  "account.autoLogin": "Automatska prijava",
  "account.userLogin": "Prijava korisnika",
  "account.registerTips": "Još nemate račun? Kliknite ovdje za registraciju",
  "account.userEmail": "Korisničko ime / e-pošta",
  "account.userEmailTips": "Unesite korisničko ime ili e-poštu",
  "account.password": "Lozinka",
  "account.passwordTips": "Unesite lozinku",
  "account.submit": "Pošalji",
  "account.submitTips": "Slanje u tijeku, molimo pričekajte...",
  "account.otherLoginTips": "Ili odaberite drugi način prijave",
  "account.userRegistration": "Registracija korisnika",
  "account.userName": "Korisničko ime",
  "account.userNameTips": "Unesite korisničko ime",
  "account.emailTips1": "Unesite adresu e-pošte",
  "account.emailTips2": "Neispravan format adrese e-pošte",
  "account.phone": "Telefonski broj",
  "account.phoneTips1": "Unesite telefonski broj",
  "account.phoneTips2": "Neispravan telefonski broj",
  "account.phoneTips3": "Unesite telefonski broj",
  "account.passwordTips1": "Unesite lozinku (6-30 znakova)",
  "account.passwordTips2": "Neispravan format lozinke: lozinka se mora sastojati od engleskih slova, brojeva, donjih crta, crta i točaka, duljina 6-12 znakova",
  "account.passwordTips3": "Dvije unesene lozinke se ne podudaraju, provjerite i unesite ponovo!",
  "account.passwordTips4": "Unesite lozinku: lozinka se mora sastojati od engleskih slova, brojeva, donjih crta, crta i točaka",
  "account.passwordTips5": "Potvrda lozinke",
  "account.passwordTips6": "Unesite potvrdu lozinke",
  "account.passwordTips7": "Dvije unesene lozinke se ne podudaraju, provjerite i unesite ponovo!",
  "account.passwordTips8": "Unesite potvrdu lozinke",
  "account.passwordTips9": "Čestitamo, registracija je uspješna!",
  "account.passwordTips10": "Vaše korisničko ime je:",
  "account.emailIs": "E-pošta je:",
  "account.goToLoginPage": "Nakon s sekundi bit ćete automatski preusmjeren na stranicu prijave",
  "account.goLogin": "Prijavi se",
  "account.goRegister": "Registriraj se",
  "account.loginSuccess": "Prijava uspješna",
  "account.email": "E-pošta",
  "account.sologn": "Pažljivo stvaramo prilagođeni energetski plan za vas",
  "account.pleaseAgree": "Pročitao/la sam i prihvatam",
  "userAgreement.privacyPolicy": "Politiku privatnosti",

  "account.code": "Verifikacijski kod",
  "account.codeTips": "Unesite verifikacijski kod",
  "account.codeTips2": "Neispravan verifikacijski kod",

    "account.inviteCodeTips": "Molimo unesite pozivni kod",
    "account.inviteCodeHint": "Molimo kontaktirajte instalatera ili osoblje za održavanje kako biste dobili pozivni kod",
  "account.modifyPasswordByAccount": "Promjena lozinke preko računa",
  "account.modifyPasswordByEmail": "Promjena lozinke preko e-pošte",
  "account.getPasswordByAccount": "Opoziv lozinke preko računa",
  "account.getPasswordByEmail": "Opoziv lozinke preko e-pošte",

  "account.sendEmailTips": "Verifikacijski kod poslan na e-poštu, provjerite je",
  "account.name": "Naziv računa",
  "account.newPassword": "Nova lozinka",
  "account.confirmNewPassword": "Potvrda nove lozinke",
  "account.nameTips": "Unesite naziv računa",
  "account.passwordModifySuccess": "Promjena lozinke uspješna",
  "account.emailCode": "E-pošta verifikacijskog koda",
  "account.emailCodeTips": "Unesite e-pošta verifikacijskog koda",
  "account.emailCodeTips2": "Neispravan e-pošta verifikacijski kod",
  "account.emailModifySuccess": "Promjena lozinke uspješna",
  "account.passworTips1": "Vaša lozinka je uspješno resetirana!",
  "account.passwordTips11": "Unesite potvrdu lozinke",
  "account.passwordTips12": "Unesite novu lozinku",
  "account.nickname": "Korisničko nadimak",
  "account.modifyNickname": "Promjena korisničkog nadimka",
  "account.modifyNicknameSuccess": "Promjena korisničkog nadimka uspješna!",
  "account.nicknameTips": "Unesite korisničko nadimak",
  "account.nicknameError": "Promjena korisničkog nadimka nije uspjela!",

  "account.login": "Prijavi se",
  "account.quickRegister": "Brza registracija",
  "account.sendCode": "Pošalji kod",
  "account.sendTips": "Nakon s sekundi možete poslati ponovo",
  "account.sendEmailIng": "Slanje e-pošte u tijeku, molimo pričekajte...",
  "account.emailNotEmpty": "Adresa e-pošte ne može biti prazna",
  "account.registerAccount": "Registriraj račun",
  "account.registerWelcome": "Dobrodošli u registraciju SusprSafe",
  "account.usernameLimit": "Korisničko ime mora početi slovom i može sadržavati samo slova, brojeve i donje crte, duljina 5-15 znakova",

  "copyright.desc2": "Informacije o registraciji web stranice: ICP registracija Guangdong br. 2021169764",

  "editUserInfo.editUserInformation": "Uređivanje korisničkih informacija",
  "editUserInfo.modifyUsername": "Promjena korisničkog imena",
  "editUserInfo.changePictures": "Promjena profilne slike",
  "editUserInfo.savePicturesSuccess": "Profilna slika korisnika uspješno spremljena",
  "editUserInfo.saveError": "Spremanje nije uspjelo",
  "editUserInfo.pictureLimit": "Slika mora biti manja od 2 MB",
  "editUserInfo.uploadPicture": "Učitaj profilnu sliku",
  "editUserInfo.picturePreview": "Pregled",
  
  "editUserInfo.bindPhoneNumber": "Povezivanje telefonskog broja",
  "editUserInfo.bindEmail": "Povezivanje e-pošte",
  "editUserInfo.changePassword": "Promjena lozinke",

  "editUserInfo.notificationSettings": "Postavke obavijesti",
  "editUserInfo.editAccount": "Uređivanje informacija o korisničkom računu",
  "editUserInfo.waitBingting": "Povezivanje u tijeku, molimo pričekajte...",
  "editUserInfo.collapse": "Sažmi",
  "editUserInfo.modifyBinding": "Promjena povezivanja",
  
  "editUserInfo.emailAddress": "Adresa e-pošte",
  "editUserInfo.tips1": "Povezivanje e-pošte uspješno",
  "editUserInfo.tips2": "Spremanje nije uspjelo",
  "editUserInfo.tips3": "Slanje e-pošte verifikacijskog koda u tijeku, molimo pričekajte...",
  "editUserInfo.tips4": "Verifikacijski kod poslan na e-poštu xxxx, provjerite je",
  "editUserInfo.tips5": "Slanje verifikacijskog koda nije uspjelo!",
  "editUserInfo.tips6": "Telefonski broj je već povezan",
  "editUserInfo.tips7": "E-pošta je već povezana",
  "editUserInfo.emailTips1": "Unesite adresu e-pošte",
  "editUserInfo.emailTips2": "Neispravan format adrese e-pošte",
  "editUserInfo.emailTips3": "Nakon xxxx sekundi možete poslati ponovo",
  "editUserInfo.emailTips4": "Pošalji kod",
  "editUserInfo.emailTips5": "E-pošta verifikacijski kod ne može biti prazan",
  "editUserInfo.emailTips6": "Neispravan e-pošta verifikacijski kod",
  "editUserInfo.emailCode": "E-pošta verifikacijskog koda",
  "editUserInfo.save": "Spremi",

  "editUserInfo.phoneTips1": "Povezivanje telefonskog broja uspješno",
  "editUserInfo.phoneTips2": "Slanje SMS verifikacijskog koda u tijeku, molimo pričekajte...",
  "editUserInfo.phoneTips3": "SMS verifikacijski kod poslan na telefon xxxx, provjerite ga",
  "editUserInfo.phoneTips4": "Slanje SMS verifikacijskog koda nije uspjelo!",
  "editUserInfo.phoneTips5": "Unesite telefonski broj",
  "editUserInfo.phoneTips6": "Neispravan format telefonskog broja",
  "editUserInfo.phoneTips7": "Pošalji SMS verifikacijski kod",
  "editUserInfo.phoneTips8": "SMS verifikacijski kod",
  "editUserInfo.phoneTips9": "SMS verifikacijski kod ne može biti prazan",
  "editUserInfo.phoneTips10": "Neispravan SMS verifikacijski kod",
  "editUserInfo.phone": "Telefonski broj",


  "editUserInfo.noticeTips1": "Dohvaćanje postavki obavijesti nije uspjelo!",
  "editUserInfo.noticeTips2": "Postavke obavijesti uspješno spremljene!",
  "editUserInfo.noticeTips3": "Obavijest o niskoj razini baterije",
  "editUserInfo.noticeTips4": "Obavijest o završetku punjenja punjača",
  "editUserInfo.errorNotification": "Obavijest o greški",
  "editUserInfo.updateNotification": "Obavijest o ažuriranju",
  "editUserInfo.monthlyStatisticsNotification": "Obavijest o mjesecnim statistikama",
  "editUserInfo.notificationMethod": "Način primanja",

  "editUserInfo.userNameTips1": "Korisničko ime uspješno spremljeno",
  "editUserInfo.userNameTips2": "Spremanje korisničkog imena nije uspjelo",
  "editUserInfo.userNameTips3": "Unesite korisničko ime",
  "editUserInfo.userNameTips4": "Neispravan format korisničkog imena: mora se sastojati od brojeva, donjih crta i engleskih slova",
  "editUserInfo.userNameTips5": "Unesite korisničko ime",
  "editUserInfo.userNameTips6": "Spremanje u tijeku, molimo pričekajte...",
  "editUserInfo.userName": "Korisničko ime",

  "editUserInfo.avatorTips": "Kliknite za promjenu profilne slike",
  "editUserInfo.verifyCodeTips1": "Unesite verifikacijski kod koji ste primili:",
  "editUserInfo.verifyCodeTips2": "Za sigurnost vašeg računa kliknite gumb ispod za slanje verifikacijskog koda na originalni telefonski broj:",
  "editUserInfo.verifyCodeTips3": "Pošalji kod",
  "editUserInfo.verifyCodeTips4": "Verifikacija originalnog telefona uspješna, unesite novi povezani telefonski broj",
  "editUserInfo.verifyCodeTips5": "Za sigurnost vašeg računa kliknite gumb ispod za slanje verifikacijskog koda na originalnu e-poštu:",
  "editUserInfo.verifyCodeTips6": "Verifikacija originalne e-pošte uspješna, unesite novu e-poštu",
  "editUserInfo.verifyCodeTips7": "Stara lozinka",
  "editUserInfo.verifyCodeTips8": "Prvo povežite e-poštu!",
  "editUserInfo.verifyCodeTips9": "Verifikacijski kod poslan na e-poštu, provjerite je",
  "editUserInfo.verifyCodeTips10": ", bit ćete automatski preusmjeren na stranicu prijave",

  "hems.notice.title": "Naslov obavijesti", 
  "hems.notice.content": "Sadržaj obavijesti", 
  "hems.notice.operate": "Akcija",
  "hems.notice.noRead": "Nepročitano",
  "hems.notice.read": "Pročitano",
  "hems.notice.warning": "Upozorenje",
  "hems.notice.error": "Greška",
  "hems.notice.success": "Statističko računanje",
  "hems.notice.sys": "Sistemska informacija",
  "hems.notice.operateSuccess": "Akcija uspješna",
  "hems.notice.operateTips": "Odaberite stavku za akciju",

  // 首页
  "hems.home.selfuseRate": "Stopa samostalnog korištenja",
  "hems.home.percent": "Postotak",
  "hems.home.todayData": "Današnji podaci",
  "hems.home.todayPowerGeneration": "Današnja proizvodnja energije",
  "hems.home.salesIncome": "Prihod od prodaje energije",
  "hems.home.saved": "Uštedili ste",
  "hems.home.reduce": "Smanjenje ugljičnog otiska",
  "hems.home.tips1": "Trenutno nema podataka, još niste povezali xxxx",
  "hems.home.criticalLoad": "Kritično opterećenje",
  "hems.home.keyVoltage": "Kritični napon",
  "hems.home.householdLoad": "Opterećenje kuće",
  "hems.home.householdVoltage": "Napon kuće",
  "hems.home.generalLoad": "Obično opterećenje",
  "hems.home.generalVoltage": "Obični napon",
  "hems.home.batteryHealth": "Zdravstveni status baterije",
  "hems.home.averageTemp": "Prosječna temperatura",
  "hems.home.gridLoad": "Opterećenje električne mreže",
  "hems.home.toggeleDataSource": "Trenutno prikazani podaci promijenjeni u:",
  "hems.home.toggleTips": "Jeste li sigurni da želite promijeniti?",
  "hems.home.modeSending": "Slanje naredbe načina rada u tijeku, molimo pričekajte...",
  "hems.home.modeSuccess": "Naredba za promjenu načina rada uspješno poslana!",
  "hems.home.isOnline": "Je li online?",
  "hems.home.useStatus": "Status korištenja",
  "hems.home.workModeText": "Trenutni način rada:",
  "hems.home.toggleDataSourceText": "Trenutno prikazani podaci promijenjeni u:",
  "hems.ev.charge.status": "Status punjenja",
  "hems.ev.charge.time": "Vrijeme punjenja",
  "hems.ev.charge.count": "Stvarni iznos punjenja",
  "hems.ev.charge.status.empty": "Slobodno",
  "hems.ev.charge.status.ing": "Punjenje s priključenom kablom",
  "hems.ev.charge.status.null": "Kabl priključen, ali bez punjenja",
  "hems.ev.charge.status.error": "Greška",
  "hems.hour": "sat",
  "hems.minue": "minuta",
  "hems.ev.chagre.number": "Broj punjača",

  // User Guide
  "hems.userGuide.selfUse": "Samostalno korištenje proizvedene energije",
  "hems.userGuide.selfUseTips": "Prvo koristite fotovoltaičnu energiju, ako nije dovoljna, nadopunite iz električne mreže",
  "hems.userGuide.economyMode": "Ekonomski način rada",
  "hems.userGuide.economyModeTips": "Optimizacija strategije korištenja energije prema cijeni električne energije",
  "hems.userGuide.emergencyMode": "Hitni način rada",
  "hems.userGuide.emergencyModeTips": "Prvo osigurati napajanje kritičnog opterećenja",

  // 图表页面
  "hems.history.energyStatistics": "Statistika energije",
  "hems.history.revenueStatistics": "Statistika prihoda",
  "hems.history.greenStatistics": "Zelena redukcija emisija",
  "hems.history.revenueTitle": "Ukupni prihod od prodaje energije",
  "hems.history.savingsTitle": "Ukupne uštede",
  "hems.history.carbonTitle": "Ukupno smanjenje ugljičnih emisija",
  "hems.history.day": "dan",
  "hems.history.month": "mjesec",
  "hems.history.year": "godina",
  "hems.history.beforeDay": "Prijašnji dan",
  "hems.history.afterDay": "Sljedeći dan",
  "hems.history.beforeMonth": "Prijašnji mjesec",
  "hems.history.afterMonth": "Sljedeći mjesec",
  "hems.history.beforeYear": "Prijašnja godina",
  "hems.history.afterYear": "Sljedeća godina",
  "hems.history.totalUse": "Ukupno korištenje",
  "hems.history.fullScreen": "Cijeli zaslon",
  "hems.history.timeSelect": "Odabir datuma",
  "sync.tips1": "Naredba za sinkronizaciju podataka uspješno poslana!",
  "sync.tips2": "Sinkronizacija podataka u tijeku, zbog velikog voluma podataka potreban je vrijeme, provjerite ponovo za pol sat vremena~",
  "sync.tips3": "Sinkronizacija podataka uređaja može imati kašnjenje, ako primijetite neslaganja u podacima, kliknite na:",
  "sync.tips4": "Sinkroniziraj podatke",

  "charge.info": "Informacije o punjaču",
  "news.loading": "Učitavanje u tijeku...",
  "news.noMore": "Nema više podataka",
  "hems.pv.power": "Količina energije iz fotovoltaike",

  // UEH specific
  "ueh.sellPower": "Količina prodane energije",
  
  "menu.home": "Početna",
  "menu.history": "Povijesni podaci",
  "menu.device": "Uređaji",
  "menu.settings": "Postavke",
  "menu.messageCenter": "Centar poruka",
  "menu.help": "Pomoć i podrška",
  "menu.mine": "Moji podaci",


  "mine.userSetting": "Postavke korisnika",
  "mine.terminalSetting": "Osnovne postavke terminala",
  "mine.uploadCloud": "Spremanje podataka u oblak",
  "mine.changeVersion": "Provjera ažuriranja",
  "mine.language": "Promjena jezika",
  "mine.about": "O aplikaciji",
  "mine.feedback": "Povratni feedback",
  "mine.logout": "Odjava",
  "mine.logoutAccount": "Brisanje računa",

  "mine.logoutAccountTips": "Brisanje računa s imenom []",
  "mine.logoutAccountTips1": "Brisanje računa povezanog s []",
  "mine.logoutAccountCare": "Poištovani, prilikom zahtjeva brisanja računa molimo Vas imati na umu sljedeće točke:",
  "mine.logoutAccountCare1": "1. Račun je u sigurnom stanju",
  "mine.logoutAccountCare1-1": "Račun je u normalnom stanju korištenja, nema rizika od krađe, kršenja pravila ili onemogućavanja.",
  "mine.logoutAccountCare2": "2. Autorizacije i povezivanja računa su uklonjeni",
  "mine.logoutAccountCare2-1": "Sve autorizacije računa s drugim trećim stranicama su uklonjene.",
  "mine.logoutAccountCare3": "3. Nakon brisanja računa ga nije moguće oporaviti, svi korisnički podaci će biti obrisani",
  "mine.logoutAccountCare3-1": "Nakon brisanja računa, povezani telefonski broj, e-pošta i drugi podaci bit će obrisani i nije moguće ih oporaviti.",
  "mine.confirmLogout": "Potvrdi brisanje",
  "mine.logoutSuccess": "Račun uspješno obrisan!",


  "mine.feedbackIssues": "Povratni feedback o problemima",
  "mine.feedQuantity": "Količina",
  "mine.feedAmount": "Maksimalno 9 slika, maksimalna veličina 1 MB po slici",

  "mine.notice.fail": "Dohvaćanje postavki obavijesti nije uspjelo!",
  "mine.notice.saveSuccess": "Postavke obavijesti uspješno spremljene!",
  "mine.notice.saveFail": "Spremanje nije uspjelo!",
  "mine.notice.title": "Postavke obavijesti",
  "mine.notice.batteryLow": "Obavijest o niskoj razini baterije",
  "mine.notice.chargingFinish": "Obavijest o završetku punjenja punjača",
  "mine.notice.error": "Obavijest o greški",
  "mine.notice.update": "Obavijest o ažuriranju",
  "mine.notice.monthly": "Obavijest o mjesecnim statistikama",
  "mine.notice.receiveType": "Način primanja",

  "mine.language.welcome": "Dobrodošli u SusprSafe",
  "mine.language.desc1": "Odaberite jezičku verziju prema vašem mjestu boravka",
  "mine.language.desc2": "Možete je promijeniti u bilo kojem trenutku kroz postavke aplikacije",

  "mine.userInfo.avatar": "Profilna slika",
  "mine.userInfo.nickname": "Nadimak",
  "mine.userInfo.password": "Lozinka",
  "mine.userInfo.changePassword": "Promjena lozinke",
  "mine.userInfo.setPassword": "Postavljanje lozinke",
  "mine.userInfo.phoneNumber": "Telefonski broj",
  "mine.userInfo.bindPhone": "Povezivanje telefonskog broja",
  "mine.userInfo.bindEmail": "Povezivanje e-pošte",
  "mine.loginExpired": "Status prijave je istekao, prijavite se ponovo",
  "mine.userInfo.title": "Korisničke informacije",
  "mine.userInfo.bind": "Poveži",
  "mine.userInfo.modify": "Uredi",
  "mine.userInfo.modifyNickname": "Promjena nadimka",
  "mine.userInfo.userNickname": "Korisnički nadimak",
  "mine.userInfo.selectPic": "Odaberite sliku za upload",
  "mine.userInfo.saveSuccess": "Spremanje uspješno",
  "mine.userInfo.uploadFail": "Upload nije uspjelo",
  "mine.userInfo.avatarSaveSuccess": "Profilna slika uspješno spremljena",
  "mine.userInfo.nameTips1": "Korisnički nadimak ne može biti prazan",
  "mine.userInfo.nameTips2": "Unesite korisnički nadimak",

  "common.pleaseSelect": "Molimo odaberite",
  "question.commonQuestions": "Česta pitanja",
  "account.toggleLanguage": "Promjena jezika",
  "account.localConnection": "Lokalna veza",
  "account.selectLanguage": "Molimo odaberite jezik",
  "account.sendEmailToast": "Verifikacijski kod poslan na e-poštu xxx, provjerite je",
  "account.emailError": "Neispravan format e-pošte",
  "account.sendEmailFail": "Slanje nije uspjelo, pokušajte ponovo",
  
  "common.submitting": "Slanje u tijeku, molimo pričekajte...",

  "device.page.noData": "Trenutno nema podataka, ovu stranicu možete pregledati samo u aplikaciji"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};